import React from "react";
import {useRefreshHook} from "src/core/common/hooks/useRefresh";
import useFiltersCatalog from "@menu/hooks/useFiltersCatalog";
import useProductCategory from "../hooks/useProductCategory";

const BaseCategoryBar = ({render}) => {
  const [catalog] = useFiltersCatalog();

  const {goToProductCategory} = useProductCategory();
  const _categories = catalog
    ? catalog.categories.filter(category => category.getParentCategoryId() === null)
    : [];

  return render({
    categories: _categories,
    onChangeCategory: goToProductCategory,
  });
};

export default function CategoryBarWrapper(props) {
  const [refreshState] = useRefreshHook();
  return <BaseCategoryBar key={refreshState} {...props} />;
}
